import { render, staticRenderFns } from "./dutyNum.vue?vue&type=template&id=c3400cd0&scoped=true"
import script from "./dutyNum.vue?vue&type=script&lang=js"
export * from "./dutyNum.vue?vue&type=script&lang=js"
import style0 from "./dutyNum.vue?vue&type=style&index=0&id=c3400cd0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3400cd0",
  null
  
)

export default component.exports